import { Link } from "react-router";

import * as styles from "./not-found-content.module.css";

export function NotFoundContent() {
	return (
		<div className={styles.container}>
			<h1 className={styles.errorCode}>404</h1>
			<p className={styles.title}>Page Not Found</p>
			<p className={styles.message}>
				The resource you are looking for might have been removed, had its name
				changed, or is temporarily unavailable.
			</p>
			<Link className={styles.button} to={"/"}>
				Return Home
			</Link>
			<p className={styles.adminNote}>
				If you believe this is an error, please contact your administrator.
			</p>
		</div>
	);
}
